<% if (note) { %>
  <div class="address-availability__note">
    <%= note %>
  </div>
<% } %>
<% if (specialNote) { %>
  <div class="address-availability__special-note">
    <%= specialNote %>
  </div>
<% } %>
